<template>
    <v-container id="appointments-table-details" fluid>
        <v-card v-if="appointment" class="pa-5" outlined>
            <div class="text-center mb-7">{{ $t("appointment.appointmentDetails") }}</div>
            <!--<div v-if="$attrs.type === 1" class="text-center mb-7">{{ $t("appointment.appointmentPending") }}</div>
            <div v-if="$attrs.type === 2" class="text-center mb-7">{{ $t("appointment.appointmentScheduled") }}</div>
            <div v-if="$attrs.type === 3" class="text-center mb-7">{{ $t("appointment.appointmentPast") }}</div>-->
            <v-row class="justify-space-between">
                <v-col class="py-0" md="6">
                    <v-row class="align-baseline">
                        <v-col class="pa-0 grey--text small" md="6">{{ $t("appointment.appointmentType") }}:</v-col>
                        <v-col v-if="typeof appointment.service.service_name === 'object'" class="pa-0" md="6">{{ appointment.service.service_name[$root.$i18n.locale] || appointment.service.service_name[Object.keys(appointment.service.service_name)[0]] }}</v-col>
                        <v-col v-else class="pa-0" md="6">{{ appointment.service.service_name }}</v-col>
                    </v-row>
                </v-col>
                <v-col class="py-0" md="5">
                    <v-row class="align-baseline">
                        <v-col class="pa-0 grey--text small" md="5">{{ $t("appointment.date") }}:</v-col>
                        <v-col class="pa-0" md="7">{{ formatDate(appointment.date_begin) }}</v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row class="justify-space-between">
                <v-col class="py-0" md="6">
                    <v-row class="align-baseline">
                        <v-col class="pa-0 grey--text small" md="6">{{ $t("appointment.lastname") }}:</v-col>
                        <v-col class="pa-0" md="6">{{ appointment.customer.last_name }}</v-col>
                    </v-row>
                </v-col>
                <v-col class="py-0" md="5">
                    <v-row class="align-baseline">
                        <v-col class="pa-0 grey--text small" md="5">{{ $t("appointment.duration") }}:</v-col>
                        <v-col class="pa-0" md="7">{{ formatDuration(appointment.service.duration) }} Min</v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row class="justify-space-between">
                <v-col class="py-0" md="6">
                    <v-row class="align-baseline">
                        <v-col class="pa-0 grey--text small" md="6">{{ $t("appointment.firstname") }}:</v-col>
                        <v-col class="pa-0" md="6">{{ appointment.customer.first_name }}</v-col>
                    </v-row>
                </v-col>
                <v-col class="py-0" md="5">
                    <v-row class="align-baseline">
                        <v-col class="pa-0 grey--text small" md="5">{{ $t("appointment.store") }}:</v-col>
                        <v-col class="pa-0" md="7">{{ appointment.location_id }}</v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row class="justify-space-between">
                <v-col class="py-0" md="6">
                    <v-row class="align-baseline">
                        <v-col class="pa-0 grey--text small" md="6">{{ $t("appointment.phone") }}:</v-col>
                        <v-col class="pa-0" md="6">{{ appointment.customer.phone }}</v-col>
                    </v-row>
                </v-col>
                <v-col v-if="['cancelled'].includes(appointment.current_status)" class="py-0" md="5">
                    <v-row class="align-baseline">
                        <v-col class="pa-0 grey--text small" md="5">{{ $t("appointment.cancelReason") }}:</v-col>
                        <v-col class="pa-0" md="7">{{ appointment.cancel_reason }}</v-col>
                    </v-row>
                </v-col>
            </v-row>
            <div class="d-flex justify-center">
                <v-btn v-if="['waiting_seller_confirmation', 'waiting_customer_confirmation'].includes(appointment.current_status)" @click="confirm" class="mt-3 mx-2" color="primary" outlined>
                    {{ $t("appointment.confirm") }}
                </v-btn>
                <v-btn v-if="['confirmed'].includes(appointment.current_status)" @click="validate" class="mt-3 mx-2" color="primary" outlined>
                    {{ $t("appointment.appointment_confirm") }}
                </v-btn>
                <v-btn v-if="['waiting_seller_confirmation', 'waiting_customer_confirmation', 'confirmed'].includes(appointment.current_status)" @click="dialog = true" class="mt-3 mx-2" color="primary" outlined>
                    {{ $t("appointment.cancel") }}
                </v-btn>
                <v-dialog v-model="dialog" max-width="400px">
                    <v-card>
                        <v-card-title style="justify-content: center;">
                            {{ $t("appointment.cancelReason") }}
                        </v-card-title>
                        <v-card-text>{{ $t("appointment.cancelWhy") }}</v-card-text>
                        <v-text-field v-model="cancelReason" filled></v-text-field>
                        <v-card-actions class="pa-0">
                            <v-btn @click="dialog = false"
                            color="secondary"
                            tile
                            class="ml-0"
                            style="width: 50%;"
                            >
                            {{ $t("appointment.cancel") }}
                            </v-btn>
                            <v-btn @click="cancel(), dialog = false"
                            color="primary"
                            tile
                            class="ml-0"
                            style="width: 50%;"
                            >
                            {{ $t("appointment.valid") }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </v-card>
        <div v-if="appointment" class="d-flex">
            <v-card v-if="displaySellerNote"  class="mt-5 pa-5 flex-grow-1" outlined>
                <div class="text-center mb-5">{{ $t("appointment.note_seller") }}</div>
                <v-textarea filled v-model="appointment.note_seller" ></v-textarea>
            </v-card>
            <v-card class="mt-5 pa-5 flex-grow-1" outlined>
                <div class="text-center mb-5">{{ $t("appointment.note") }}</div>
                <v-textarea filled v-model="appointment.note" ></v-textarea>
            </v-card>
        </div>
        <div class="d-flex justify-center">
            <v-btn @click="save" class="my-3" color="primary" outlined>
                {{ $t("appointment.save") }}
            </v-btn>
        </div>
    </v-container>
</template>

<script>
import moment from 'moment';
import {mapState} from 'vuex'

export default {
    name: 'InStoreAppointmentsTableDetails',
    data() {
        return {
            appointment: null,
            displaySellerNote: false,
            dialog: false,
            cancelReason: ""
        }
    },
    created() {
        this.getAppointmentById(this.$route.params.id)
    },
    computed: {
        ...mapState(['isOctipasAdmin', 'isAdmin']),
    },
    methods: {
        async getAppointmentById(id) {
            let myInit = {
                headers: {
                    "Authorization": 'Bearer ' + this.$auth.accessToken
                },
                body: this.appointment
            }
            this.appointment = await this.$Amplify.API.get("appointments", `/appointments/${id}`, myInit);
        },
        buildMyInit(type = null){
            let headers = {"Authorization": 'Bearer ' + this.$auth.accessToken};
            let appointment = this.appointment;
            switch (type) {
                case 1:
                    appointment.current_status = "done";
                    return {headers, body: appointment}
                case 2:
                    appointment.current_status = "cancelled";
                    appointment.cancel_reason = this.cancelReason;
                    return {headers, body: appointment}
                case 3:
                    appointment.current_status = "confirmed";
                    return {headers, body: appointment}
                case 4:
                    return {headers, body: appointment}
                default:
                    return {headers}
            }
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YY hh:mm')
        },
        formatDuration(duration){
            let time = duration / 60;
            return ~~time;
        },
        async validate() {
            await this.$Amplify.API.put("appointments", `/appointments/${this.$route.params.id}`, this.buildMyInit(1));
            this.$router.push({
                name: "appointments", 
                params: {
                    type: "past"
                }
            });
        },
        async cancel() {
            await this.$Amplify.API.put("appointments", `/appointments/${this.$route.params.id}`, this.buildMyInit(2));
            this.$router.push({
                name: "appointments",
                params: {
                    type: "past"
                }
            });
        },        
        async confirm() {
            await this.$Amplify.API.put("appointments", `/appointments/${this.$route.params.id}`, this.buildMyInit(3));
            if (this.isAdmin) {
                this.$router.push({
                    name: "appointments",
                })
            } else {
                this.$router.push({
                    name: "appointments",
                    params: {
                        type: "scheduled"
                    }
                });
            }
            
        },
        async save() {
            await this.$Amplify.API.put("appointments", `/appointments/${this.$route.params.id}`, this.buildMyInit(4));
            this.$router.push({
                name: "appointments",
            })
        },
    },
}
</script>
<style scoped>
    .small {
        font-size: 14px;
    }
</style>